<template>
  <div class="box">
    <div class="flex space-between" style="padding-bottom:20px">
      <div class="flex align-center">
        <span>검색결과 {{ filteredCount }} 개</span>
        <span v-if="totalPrice!==undefined"><span style="margin:0 4px">/</span>총 주문금액 {{ totalPrice | currency }}</span>
        <!--<span>개 <span style="color:#ccc"> / </span> 전체</span>
        <span> {{ allCount }}</span>
        <span>개</span>-->
      </div>
      <div class="flex-align">
        <div class="flex-align" style="margin-right:8px">
          <toggle-button @change="e=>enableDragScroll = e.value"
                         :value="enableDragScroll"
                         :sync="true"
                         class="changed-font"
                         :width="50"
                         :height="24"></toggle-button>
          <span style="margin-left:4px">좌우로 스와이프</span>
          <i class="material-icons" style="font-size:17px;margin-left:2px">open_with</i>
        </div>
        <!-- 10개씩보기 -->
        <div class="control">
          <span class="select">
            <select v-model="page_length" @change="selPageLength">
              <option v-for="(it,idx) in pageLengthList" :key="'list-'+idx"
                      :value="it.value">{{ it.label }}</option>
            </select>
          </span>
        </div>
      </div>
    </div>
    <scroll-table-wrapper :enableDragScroll="enableDragScroll">
      <!-- 테이블 -->
      <table class="table" style="table-layout: fixed" :style="tableStyle">
        <thead>
        <tr>
          <th v-for="(field,idx) in field_list" :key="'field-'+idx" :style="'width:'+field.width">
            <lp-ordering
              :data="field"
              @onSelect="res => $emit('ordering', res)"
              v-if="enableOrdering(field.eng_name)">
                <span style="display:inline-block"
                      v-if="field.eng_name!=='checkspot'">{{ field.ko_name }}</span>
            </lp-ordering>
            <!--<img src="/static/image/checked.png" style="width: 16px; height: 16px" v-else-if="field.eng_name==='checkspot'">-->
            <div v-else-if="field.eng_name==='checkspot'">
              <lp-check-bool :checked-val="check" @onCheck="clickCheckBox"></lp-check-bool>
            </div>
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, trIdx) in items" :key="`trIdx-${trIdx}`"  @click="clickCheckBoxTr(trIdx)" class="unselect">
          <slot :name="field.eng_name" :item="item" :idx="trIdx" v-for="field in field_list"></slot>
        </tr>
        </tbody>
      </table>
    </scroll-table-wrapper>

    <!-- 선택승인, 선택 미승인 같은 post요청을 하는 경우 -->
    <div>
      <slot name="spot"></slot>
    </div>

    <!-- 페이지 -->
    <div class="pagination-group" v-if="pagination">
      <div class="pagination-btn-prev" @click="startPage">
        <i class="material-icons unselect" style="margin-top:5px;margin-right:-18px">keyboard_arrow_left</i>
        <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
      </div>
      <div class="pagination-btn-prev" @click="prevPage">
        <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
      </div>
      <div class="pagination-num" v-for="(n,idx) in calcPageList" :key="'page-'+idx">
        <span
          class="unselect"
          :class="{
            'pagination-num-selected': n === filtered.page_num,
            'pagination-num-not-selected': n !== filtered.page_num,
          }"
          @click="changePage(n)"
          style="font-size:1.2rem">{{ n }}</span>
      </div>
      <div class="pagination-btn-next" @click="nextPage">
        <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
      </div>
      <div class="pagination-btn-next" @click="endPage">
        <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
        <i class="material-icons unselect" style="margin-top:5px;margin-left:-18px">keyboard_arrow_right</i>
      </div>
    </div>
  </div>
</template>

<script>
  import LpOrdering from "../common/LpOrdering";
  import pageLengthStructure from './pageLengthStructure'
  import numeral from 'numeral'
  import LpCheckBool from "../common/LpCheckBool";
  import ScrollTableWrapper from "../common/ScrollTableWrapper";

  export default {
    /*
    * filtered: { page_num:1, page_length:10 ... }
    * filed_list: [ { eng_name: id, ko_name: 번호, width: 65px }, {}, {} ...  ]
    * items: 디비에서 가져온 테이블 구성할 데이터 [{ id:9, name:'김준호', email:'asda@sad.com' }]
    * tabble_width는 min-width값을 주기 위함
    *
    * */
    props:['field_list', 'items', 'filtered', 'table_width',
      'title', 'filteredCount', 'allCount', 'totalPrice'],
    components: {
      ScrollTableWrapper,
      LpCheckBool,
      LpOrdering},
    data(){
      return {
        /*fields:['id','created_time'],
        items:[{'id':1, 'created_time': '2012-03-24'}]*/
        pageLengthList: pageLengthStructure.common,
        page_length:10,
        pagination: true,
        block: 1,
        start: 1,
        end: 10,
        check: false,
        enableDragScroll: false
      }
    },
    computed: {
      tableStyle(){
        if(this.table_width){
          return 'min-width:' + this.table_width + 'px';
        }
        else {
          return 'min-width: 1400px';
        }
      },
      calcPageList() {
        let page_list = [];
        for(let i=this.start; i<=this.end; i++) {
          page_list.push(i);
        }
        return page_list;
      }
    },
    watch: {
      '$route'() {
        this.page_length = 10;
      },
      filtered: {
        handler(val) {
          if(this.filtered.page_num===1) {
            this.start = 1;
            this.block = 1;
          }
          if(this.start + 9 >= this.filtered.total_page) {
            this.end = this.filtered.total_page;
          }
          else if(this.block===1) {
            this.end = 10;
          }
        },
        deep: true
      },
      'filtered.total_page'(n) {
        // console.log(n)
        // if(this.filtered.total_page<10) this.end = this.filtered.total_page;
        if(this.start + 9 >= this.filtered.total_page) {
          this.end = this.filtered.total_page;
        }
      }
    },
    methods:{
      clickCheckBoxTr(trIdx) {
        this.$emit('checkItem', trIdx);
      },
      clickCheckBox() {
        this.check = !this.check;
        this.$emit('check', this.check);
      },
      // 내용이 긴 경우에 ellipsis 처리하고 싶은 경우 nameArr에 structure.js에 필드의 영문네임을 배열에 추가해주면 됩니다.
      tdStyle(field){
        let width = 'width:'+field.width+';';
        let ellipsis = 'white-space:nowrap; overflow:hidden; text-overflow: ellipsis;';

        let nameArr = ['content', 'comment', 'answer', 'question', 'answer_content', 'question_content', 'order_content', 'counsel_content', 'choice_items'];
        for(let i=0; i<nameArr.length; i++){
          if(field.eng_name===nameArr[i]){
            return width + ellipsis;
          }
        }
        return '';
      },
      selPageLength(){
        this.$emit('selPageLength',this.page_length);
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.filtered.cur_page = num;
        this.$emit('getData');
      },
      prevPage() {
        if (this.filtered.page_num - 10 >= 1) {
          this.block -= 1;
          this.start = (this.block-1)*10+1;
          this.end = this.start + 9;
          this.filtered.page_num = this.start;
          this.filtered.cur_page = this.start;
          this.$emit('getData');
        }
      },
      nextPage() {
        if (this.filtered.page_num + 10 <= this.filtered.total_page) {
          this.block += 1;
          this.start = (this.block-1)*10+1;
          if(this.start + 9 >= this.filtered.total_page) {
            this.end = this.filtered.total_page;
          }
          else {
            this.end = this.start + 9;
          }
          this.filtered.page_num = this.start;
          this.filtered.cur_page = this.start;
          this.$emit('getData');
        }
        else {
          let next_block = this.block+1;
          if ((next_block - 1) * 10 + 1 <= this.filtered.total_page) {
            this.block += 1;
            this.start = (this.block - 1) * 10 + 1;
            this.end = this.filtered.total_page;
            this.filtered.page_num = this.start;
            this.filtered.cur_page = this.start;
            this.$emit('getData');
          }
        }
      },
      startPage() {
        this.block = 1;
        this.start = (this.block-1)*10+1;
        if (this.filtered.total_page>10) this.end = this.start + 9;
        else this.end = this.filtered.total_page;
        this.filtered.page_num = 1;
        this.filtered.cur_page = 1;
        this.$emit('getData');
      },
      endPage() {
        let block = Math.floor(this.filtered.total_page/10);
        let remainder = this.filtered.total_page % 10;
        if(remainder > 0) block += 1;
        this.block = block;
        this.start = (this.block-1)*10+1;
        this.end = this.filtered.total_page;
        this.filtered.page_num = this.filtered.total_page;
        this.filtered.cur_page = this.filtered.total_page;
        this.$emit('getData');
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      // exhibition일때 ordering 예외처리
      enableOrdering(name){
        if(name==='exhibition' || name==='purchase' || name==='checkspot'){
          return false;
        }
        // 커머스 일때 오더링 숨김
        else if(this.$route.path.search('commerce')>-1){
          return false;
        }
        else return true;
      }
    }
  }
</script>

<style lang="scss">
  .table td, .table th {
    vertical-align: middle;
  }
  tr:hover {
    td {
      background-color: #eeeeee;
    }
  }

  .pagination-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .pagination-btn-prev
  .pagination-btn-next {
    display: inline-block;
    height: 25px;
  }

  .pagination-num {
    display: inline-block;
  }

  .pagination-btn-prev i
  .pagination-btn-next i {
    color: #18a4ed;
    margin: 4px;
    cursor: pointer;
  }

  .pagination-num {
    padding: 5px 8px;
    cursor: pointer;
    font-size: .9rem;
  }

  .pagination-num-selected {
    color: #18a4ed;
  }

  .pagination-num-not-selected {
    color: #666;
  }

  // 테이블 상태 관련 버튼
  .state-btn {
    width: 100px;
  }

  .ests-btn-confirm-new {     // 신규요청확인
    background-color: #ffb100;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .ests-btn-request-sheet {     // 견적서 의뢰
    color: #fff;
    background-color: #5cb85c;
    cursor: pointer;
    border: none;
  }

  .ests-btn-write-sheet {    // 견적서 작성
    background-color: #008fd9;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .ests-btn-accept-order {    // 주문 승인
    background-color: #ffb100;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .ests-btn-deny-order {    // 주문 거절
    background-color: #db2828;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .btn-make-comment {    // 상품후기 답변 달기
    background-color: #ebab39;
    color: #fff;
    cursor: pointer;
    border: none;
  }

  .btn-edit-comment {    // 상품후기 답변 수정
    background-color: #064160;
    color: #fff;
    cursor: pointer;
    border: none;
  }


</style>
